import Jennifer from '../assets/images/brokers/jennifer-mckeown.webp'
import Chauvin from '../assets/images/brokers/ann-chauvin.webp'
import Pratte from '../assets/images/brokers/yves.pratte.webp'
import Olney from '../assets/images/brokers/gladys_olney.webp'
import Richardson from '../assets/images/brokers/kim_richardson.webp'
import Dalbec from '../assets/images/brokers/paul.dalbec.webp'
import LÈonard from '../assets/images/brokers/Louise Leonard (1).webp'
import Jeffreys from '../assets/images/brokers/ann_jeffreys.webp'
import Maillet from '../assets/images/brokers/caroline-maillet.webp'
import Enoaie from '../assets/images/brokers/Corina Enoaie (1).webp'
import Boon from '../assets/images/brokers/emy_boon.webp'
import Couchman from '../assets/images/brokers/sean.couchman.webp'
import Martineau from '../assets/images/brokers/emma_martineau.webp'
import Bota from '../assets/images/brokers/myriane-bota.webp'
import Simard from '../assets/images/brokers/ksimard.webp'
// import Balthazard from '../assets/images/brokers/laurier-2021.jpg'
import Naud from '../assets/images/brokers/myriam-naud.webp'
// import Bauer from '../assets/images/brokers/jo-bauer.webp'
import Ouimet from '../assets/images/brokers/Pierre Ouimet.webp'
import Griffin from '../assets/images/brokers/cynthia-griffin.webp'
import Lambert from '../assets/images/brokers/Veronique Lambert (1).webp'
import Philippe from '../assets/images/brokers/Philippe Genest.webp'





 export   const  brokersFrData = [
    {
      "CODE": "59807",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "B5489",
      "TYPE_CERTIFICAT": "CIADA",
      "NOM": "McKeown",
      "PRENOM": "Jennifer",
      
      "TITRE_PROFESSIONNEL": "Courtier immobilier agréé/Dirigeant d'agence (DA)",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-0074",
      "TELEPHONE_2": "8194259324",
      "TELEPHONE_FAX": "8194253640",
      "COURRIEL": "jmckeown@mtre.ca",
      "INSTA":"https://www.instagram.com/jennifermckeown123/",
      "LINKEDIN":"https://www.linkedin.com/in/jennifer-mckeown-a701032/overlay/about-this-profile/",
      "FB":"https://www.facebook.com/jennifermckeowntremblantrealestate",
      "SITE_WEB": "http://www.tremblantrealestate.ca",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "A",
      "PHOTO_URL": Jennifer,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "Jennifer McKeown Immobilier inc.",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Jennifer McKeown est co-fondatrice des Immeubles Mont Tremblant. Cette agence immobilière de type ‘boutique’ avec services complets est le chef de file à Mont-Tremblant. Les Immeubles Mont Tremblant couvre toute la région du Centre de villégiature de Tremblant et ses environs, incluant de magnifiques domaines dans le corridor des Laurentides. Jennifer a connu une carrière remarquable dans la région comme un des meilleurs agents pour le nombre d’inscriptions et de ventes, grâce à sa longue association avec le club-fondateur d’acheteurs d’élite qui a contribué à faire de Mont-Tremblant le centre de villégiature #1 dans l’est de l’Amérique du Nord. Elle cumule d’impressionnantes réussites dans l’immobilier et elle a joué un rôle prépondérant dans la création du Centre de villégiature Mont Tremblant. Jennifer a fondé Les Immeubles Mont Tremblant en 1996 pour répondre à la demande de plus en plus forte pour une agence immobilière professionnelle à Mont-Tremblant. Depuis lors elle a géré, avec son équipe, des transactions de plusieurs millions de dollars dans la région. Lorsqu’il s’agit d’acheter ou de vendre dans un marché de luxe, les promoteurs immobiliers ainsi que les acheteurs individuels apprécient les connaissances, la créativité et l’expérience de Jennifer. Grâce à son expertise et son instinct sur les habitudes des acheteurs ainsi que les attentes des vendeurs, elle sait prodiguer de judicieux conseils à ses clients et elle les guide tout au long de leur transaction. La personnalité attachante de Jennifer, son sens inné de l’esthétique ainsi qu’une dévotion sans faille pour ses clients reflètent parfaitement la philosophie des Immeubles Mont Tremblant.",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    // {
    //   "CODE": "65108",
    //   "BUR_CODE": "ITT001",
    //   "NO_CERTIFICAT": "B2906",
    //   "TYPE_CERTIFICAT": "AF",
    //   "NOM": "Chauvin",
    //   "PRENOM": "Ann",
    //   "TITRE_PROFESSIONNEL": "Courtier Immobilier",
    //   "CHAMP_INUTILISE_1": "",
    //   "TELEPHONE_1": "1 (819) 425-4089",
    //   "TELEPHONE_2": "8194253777",
    //   "TELEPHONE_FAX": "",
    //   "COURRIEL": "achauvin@mtre.ca",
    //   "SITE_WEB": "http://www.royallepagetremblant.com",
    //   "CHAMP_INUTILISE_2": "",
    //   "CODE_LANGUE": "A",
    //   "PHOTO_URL": Chauvin,
    //   "DATE_MODIFICATION": "2024/10/09 18:07:35",
    //   "NOM_SOCIETE": "",
    //   "TYPE_SOCIETE_DESC_F": "",
    //   "TYPE_SOCIETE_DESC_A": "",
    //   "LIEN_VIDEO_F": "",
    //   "LIEN_VIDEO_A": "",
    //   "PRESENTATION_F": "",
    //   "PRESENTATION_A": "\r",
    //   "description":"Je pratique l’immobilier depuis plus de 25 ans et j’aime travailler avec des clients provenant de nombreux pays et des différentes provinces du Canada. J’aime trouver la maison idéale pour mes clients et de nombreux clients m’ont remerciée pour mon professionnalisme. J’ai également réussi à trouver des maisons de ville ou des condos pour les clients, en particulier dans la région de Nansenhus. Beaucoup de ces clients sont venus me voir lorsqu’ils ont décidé de vendre et j’ai travaillé dur pour que leur vente se déroule sans heurts. L’immobilier a pris de l’ampleur dans la région de Mont-Tremblant et de nombreuses personnes souhaitent désormais posséder des maisons dans la région pour faire du vélo, de la randonnée, du ski ainsi que des activités tel que le Ironman. Je continuerai à travailler dur pour permettre aux clients trouver la propriété de leurs rêves!",
    //   "company_info": {
    //     "CODE": "ITT001",
    //     "FIRME_CODE": "ITT",
    //     "NOM_LEGAL": "SIEGE SOCIAL",
    //     "NO_CIVIQUE": "2195",
    //     "NOM_RUE": "Ch. du Village",
    //     "BUREAU": "",
    //     "MUNICIPALITE": "Mont-Tremblant",
    //     "PROVINCE": "QC",
    //     "CODE_POSTAL": "J8E3M3",
    //     "TELEPHONE_1": "8194259324",
    //     "POSTE_1": "",
    //     "TELEPHONE_2": "8194253777",
    //     "POSTE_2": "",
    //     "TELEPHONE_FAX": "8194253640",
    //     "COURRIEL": "info@mtre.ca",
    //     "SITE_WEB": "https://www.tremblantrealestate.ca/",
    //     "DIRECTEUR_CODE": "59807",
    //     "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
    //   }
    // },
    {
      "CODE": "77026",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "C5532",
      "TYPE_CERTIFICAT": "AF",
      "NOM": "Pratte",
      "PRENOM": "Yves",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-0827",
      "TELEPHONE_2": "",
      "TELEPHONE_FAX": "",
      "COURRIEL": "ypratte@mtre.ca",
      "LINKEDIN":"https://www.linkedin.com/in/yves-pratte-000a8959/",
      "SITE_WEB": "",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "F",
      "PHOTO_URL": Pratte,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Passionné des Laurentides, Yves vit à Tremblant depuis 1981 afin de profiter le plus possible des activités extérieures de la région. Adepte de ski alpin, de ski de fond, de fatbike, de vélo de montagne et de route, il adore les sports d’action surtout quand il les partage avec ses quatre garçons. En affaires comme en sport, Yves aime se surpasser. Courtier immobilier à Tremblant depuis 23 ans, il mène sa carrière de la même façon. Sa vision est de faire une différence dans la vie des gens. Tant au niveau professionnel que personnel, son objectif premier est d’ajouter de la valeur à tout ce qu’il entreprend. C’est une des raisons pour laquelle il bâtit des relations durables et qu’il travaille par références. En plus de ces nombreuses années d’expérience dans la vente et dans l’immobilier, Yves possède une grande expertise immobilière pour les transactions de condos, de maisons située au bord de l’eau, de chalets, de terrains et de terres et ceci, pour la vaste région des Laurentides. Diplômé de l’UQAM en marketing, il offre une approche très adaptée aux besoins de sa clientèle. Pour lui, les résultats découlent d’un excellent service à la clientèle, d’intégrité et d’enthousiasme. Il aime promettre beaucoup mais préfère livrer davantage!",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    {
      "CODE": "77799",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "C6923",
      "TYPE_CERTIFICAT": "AF",
      "NOM": "Olney",
      "PRENOM": "Gladys",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-4654",
      "TELEPHONE_2": "8194259324",
      "TELEPHONE_FAX": "",
      "COURRIEL": "gladysolney@mtre.ca",
      "INSTA":"https://www.instagram.com/lada_lovegladys/",
      "LINKEDIN":"https://www.linkedin.com/in/gladys-olney-5846157/overlay/about-this-profile/",
      "FB":"https://www.facebook.com/olneyagent/",
      "SITE_WEB": "",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "A",
      "PHOTO_URL": Olney,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Représentant les propriétaires et les futurs propriétaires de la région de Mont-Tremblant, Gladys s’engage à écouter les besoins de ses clients et à utiliser son sens aigu des négociations pour assurer le succès de la transaction. En tant que résidente de Mont-Tremblant depuis près de 25 ans, Gladys comprend les nombreux avantages immatériels de la vie dans cette belle région, avec son paysage naturel inégalé, sa station de ski et de golf de renommée internationale et son large éventail d’activités et de festivals d’hiver et d’été. Gladys est arrivée dans la région en 1995 où elle a planté ses racines et a élevé sa famille. Elle a conclu des centaines de transactions réussies depuis son entrée dans le secteur de l’immobilier en 1998 et a laissé une myriade de clients satisfaits dans son sillage.",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    {
      "CODE": "78734",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "C8103",
      "TYPE_CERTIFICAT": "AF",
      "NOM": "Richardson",
      "PRENOM": "Kim",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-4836",
      "TELEPHONE_2": "8194259324",
      "TELEPHONE_FAX": "",
      "COURRIEL": "krichardson@mtre.ca",
      "INSTA":"https://www.instagram.com/yourpartnersinrealestate/",
      "LINKEDIN":"https://www.linkedin.com/in/kim-richardson-53472458/overlay/about-this-profile/",
      "FB":"https://www.facebook.com/VosPart",
      "SITE_WEB": "http://www.yourpartnersinrealestate.com",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "A",
      "PHOTO_URL": Richardson,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Courtier immobilier résidentiel/commercial, Kim possède plus de 20 ans d’expérience ainsi que des connaissances accrues dans le domaine. Avant d’obtenir sa licence de l’OCAIQ, elle a travaillé pour Intrawest Development Corp. et a également eu une longue carrière dans la vente de médias et de conférences avec Southex, Industrial Consumer Shows et Rawlco Communications. Kim comprend le marché immobilier du centre de villégiature et connaît très bien Tremblant et la région environnante. Son équipe, Your Partners in Real Estate, s’est méritée, et ce régulièrement, la récompense Diamant Rouge pour Royal Lepage et a reçu le prestigieux Chairman’s Club. Son instinct vous permettra d’en savoir davantage sur ce qui constitue un bon investissement et sur les propriétés et/ou les secteurs qui répondront le mieux à vos besoins. Kim est professionnelle, courtoise et il est très agréable de travailler avec elle. Elle peut vous guider tout au long du processus de vente, qu’il s’agisse de l’inscription ou de l’achat. L’équipe dispose d’un vaste inventaire et d’un grand nombre de références et de clients. Ce sont des spécialistes du marketing et d’excellents courtiers. N’hésitez pas à contacter Kim et son équipe de Your Partners in Real Estate pour tous vos besoins immobiliers.",
      
      
    },
    {
      "CODE": "80189",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "C2585",
      "TYPE_CERTIFICAT": "CIADA",
      "NOM": "Dalbec",
      "PRENOM": "Paul",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier Agréé",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-4008",
      "TELEPHONE_2": "8194253777",
      "TELEPHONE_FAX": "",
      "COURRIEL": "pdalbec@mtre.ca",
      "INSTA":"https://www.instagram.com/pauldalbec/",
      "LINKEDIN":"https://www.linkedin.com/in/pauldalbec/overlay/about-this-profile/",
      "FB":"https://www.facebook.com/dalbecbalthazard/",
      "SITE_WEB": "http://www.tremblantrealestate.ca",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "F",
      "PHOTO_URL": Dalbec,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "Paul Dalbec Immobilier inc.",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Qui est l’homme derrière ce nom que l’on voit sur les enseignes ‘À vendre’ à Mont-Tremblant et ses environs? Il s’agit de Paul Dalbec. Un courtier local et basé à Tremblant qui, depuis 30 ans, trouve et vend des propriétés uniques qui changent la vie de ses clients. Cet homme, d’un entregent naturel, très actif dans la communauté, est non seulement un passionné de la vente immobilière mais aussi de la vie, du ski et du plein air. Depuis 20 ans, il est dans les meilleurs 25 courtiers de Royal Lepage au Québec et 6 fois dans le Top 10 de ce groupe. Il a également été propriétaire de Royal Lepage région Mont-Tremblant depuis 1998. En avril 2018, Royal Lepage région Mont-Tremblant fusionne avec Les Immeubles Mont- Tremblant pour devenir la plus grande agence de Mont-Tremblant. Alors, quel est le secret de Paul ? Une vitalité infatigable, une volonté d’embrasser le changement, et la recherche continue de Paul pour de nouvelles façons d’aimer son travail chaque jour. En créant un lien de confiance avec ses clients acheteurs et vendeurs, en leur fournissant de précieux conseils, Paul s’assure que chaque transaction se passe en douceur. Il bâtit des relations et non des transactions. Paul a su se démarquer au fils des ans dans l’art de la négociation. Il est engagé à négocier les meilleurs ententes et conditions fondés sur vos besoins spécifiques. Avec son dévouement et son sens du détail il sera répondre à vos attentes et tentera même de les dépassés. Si vous cherchez de la qualité, de l’intégrité et un courtier honnête qui vous soutiendra toujours, ne cherchez pas plus loin, Paul Dalbec est l’homme de la situation.",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    {
      "CODE": "83557",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "D3868",
      "TYPE_CERTIFICAT": "AF",
      "NOM": "Léonard",
      "PRENOM": "Louise",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "819-681-6955",
      "TELEPHONE_2": "8194259324",
      "TELEPHONE_FAX": "8194253640",
      "COURRIEL": "louisel@mtre.ca",
      "INSTA":"https://www.instagram.com/louiseleonardcourtier/",
      "LINKEDIN":"https://www.linkedin.com/in/louise-l%C3%A9onard-42975713a/overlay/about-this-profile/",
      "FB":"https://www.facebook.com/monttremblantimmobilier/",
      "SITE_WEB": "http://www.tremblantrealestate.ca",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "F",
      "PHOTO_URL": LÈonard,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Native des hautes Laurentides, j’ai travaillé 20 ans dans le domaine de la vente en Ontario, dans le pharmaceutique et propriétaire d’une compagnie de transport. De retour au Québec depuis maintenant 20 ans, je pratique la profession de courtier immobilier dans les hautes Laurentides depuis 15 ans. Je me spécialise dans la vente et l’achat de chalet et de bords de l’eau situés dans les hautes Laurentides et dans la région de Tremblant. J’offre un service bilingue et professionnel. Je suis fière de travailler avec une équipe professionnelle et de haut calibre. Vous recherchez un agent à votre écoute pour vous aider à vendre et ou à acheter, n’hésitez pas à communiquer avec moi.",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    {
      "CODE": "84130",
      "BUR_CODE": "ITT001",
      "NO_CERTIFICAT": "D4626",
      "TYPE_CERTIFICAT": "CIADA",
      "NOM": "Jeffreys",
      "PRENOM": "Ann",
      "TITRE_PROFESSIONNEL": "Courtier Immobilier Agréé",
      "CHAMP_INUTILISE_1": "",
      "TELEPHONE_1": "1 (819) 425-1524",
      "TELEPHONE_2": "8194259324",
      "TELEPHONE_FAX": "",
      "COURRIEL": "ajeffreys@mtre.ca",
      "SITE_WEB": "http://www.annjeffreys.com",
      "INSTA":"https://www.instagram.com/yourpartnersinrealestate/",
      "FB":"https://www.facebook.com/VosPart",
      "CHAMP_INUTILISE_2": "",
      "CODE_LANGUE": "A",
      "PHOTO_URL": Jeffreys,
      "DATE_MODIFICATION": "2024/10/09 18:07:35",
      "NOM_SOCIETE": "",
      "TYPE_SOCIETE_DESC_F": "",
      "TYPE_SOCIETE_DESC_A": "",
      "LIEN_VIDEO_F": "",
      "LIEN_VIDEO_A": "",
      "PRESENTATION_F": "",
      "PRESENTATION_A": "\r",
      "description":"Native de Mont-Tremblant et troisième génération d’agents immobiliers locaux dans sa famille, Ann a plus de 15 ans d’expérience dans la vente de biens immobiliers dans les Laurentides. En tant que courtière agréée, Ann a obtenu le plus haut niveau de formation immobilière disponible afin de faciliter les transactions pour les acheteurs et les vendeurs. Avant d’entreprendre sa carrière dans l’immobilier, Ann a été directrice de comptes pour une agence de publicité, responsable des comptes de centres de villégiature et de développement immobilier importants, ainsi que directrice des ventes de groupe pour Tremblant Resort. Elle a participé à la planification stratégique de campagnes de communication, de marketing et de vente, ainsi qu’à l’analyse et au développement de produits. Avec ses partenaires en immobilier, Kim Richardson et Emma Martineau, elle s’efforce de dépasser les attentes de ses clients et d’assurer le bon déroulement des transactions immobilières du début à la fin. ",
      "company_info": {
        "CODE": "ITT001",
        "FIRME_CODE": "ITT",
        "NOM_LEGAL": "SIEGE SOCIAL",
        "NO_CIVIQUE": "2195",
        "NOM_RUE": "Ch. du Village",
        "BUREAU": "",
        "MUNICIPALITE": "Mont-Tremblant",
        "PROVINCE": "QC",
        "CODE_POSTAL": "J8E3M3",
        "TELEPHONE_1": "8194259324",
        "POSTE_1": "",
        "TELEPHONE_2": "8194253777",
        "POSTE_2": "",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "info@mtre.ca",
        "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "DIRECTEUR_CODE": "59807",
        "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      }
    },
    {
        "CODE": "94545",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "E4911",
        "TYPE_CERTIFICAT": "AF",
        "NOM": "Maillet",
        "PRENOM": "Caroline",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 808-9404",
        "TELEPHONE_2": "8144259324",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "cmaillet@mtre.ca",
        "INSTA":"https://www.instagram.com/caroline.maillet.immobilier/",
        "LINKEDIN":"https://www.linkedin.com/in/carolinemailletrealtor/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/carolinemailletrealestate",
        "SITE_WEB": "http://www.carolinemaillet.com",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Maillet,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Caroline est au seins de l’équipe des Immeubles Mont-Tremblant depuis 2010 et Courtier depuis 2008. Son important bagage de connaissances dans les ventes, avec plus de dix années d’expérience dans l’industrie internationale du vêtement, l’avait bien préparée à relever le défi de l’immobilier. Ce choix de carrière a conduit Caroline à devenir un élément moteur du marché immobilier de Tremblant. Sa vaste clientèle se compose tant de personnes désireuses de trouver une résidence principale, que de gens à la recherche d’une résidence secondaire, d’un terrain ou d’une propriété commerciale. Caroline a une bonne capacité d’écoute et elle prend le temps de bien comprendre les besoins de ses clients pour ensuite trouver la propriété qui leur convient. Finalement, Caroline est une personne bien branchée. Elle s’est tissé un solide réseau qui comprend des clients locaux et non-résident Canadien, des investisseurs, des acheteurs et des vendeurs d’ici et d’ailleurs. Sa connaissance approfondie du marché, ses aptitudes en négociation, sa grande connaissance des règlements liés aux non-résidents et son bilinguisme font d’elle une agente immobilière très professionnelle, apte à répondre à toutes les demandes en matière d’immobilier. Récipiendaire 2018 Palme D’Or du Président, Royal Lepage.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "103627",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "G1851",
        "TYPE_CERTIFICAT": "AF",
        "NOM": "Enoaie",
        "PRENOM": "Corina",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 421-0373",
        "TELEPHONE_2": "8194259324",
        "TELEPHONE_FAX": "",
        "COURRIEL": "ecorina@mtre.ca",
        "SITE_WEB": "https://tremblant.realestate",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "INSTA":"https://www.instagram.com/corina_mont_tremblant/",
        "LINKEDIN":"https://www.linkedin.com/in/corina-enoaie-7a52b534/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/ecorinaimmobiliertremblant",
        "YT":"https://www.youtube.com/channel/UCXbsnXIKfuA5K0vaVfez53Q/videos",
        "PHOTO_URL": Enoaie,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "Corina Enoaie Immobilier Inc.",
        "TYPE_SOCIETE_DESC_F": "SociÈtÈ par actions d'un courtier immobilier rÈsidentiel et commercial",
        "TYPE_SOCIETE_DESC_A": "Business corporation owned by a Residential and Commercial Real Estate Broker",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "Depuis l'‚ge de 18 ans, j'ai travaillÈ dans la vente, contribuant au commerce familial. AprËs avoir embrassÈ une carriËre enrichissante dans l'industrie du ski en tant que monitrice, superviseur et directrice d'une Ècole de ski, j'ai finalement trouvÈ ma ",
        "PRESENTATION_A": "Since the age of 18, I have been working in sales, contributing to the family business. After embracing a fulfilling career in the ski industry as an instructor, supervisor, and ski school director, I finally found my calling in real estate in 2011, and i",
        "description":"Corina se spécialise en courtage immobilier dans la région de Mont-Tremblant, une région reconnue pour le ski et le golf à l’échelle internationale. Courtière immobilière depuis 2011, Corina est une personne déterminée. Elle sait accompagner les gens dans l’achat ou la vente d’un de leur plus important bien et en fait une expérience positive et agréable. La formation continue fait partie de son cheminement professionnel. Puisque l’immobilier est un domaine où la technologie change très rapidement, elle sait qu’être à l’affût des nouvelles technologies est essentiel autant pour elle que pour ses clients. Se faisant un devoir d’aider les gens à réaliser leurs objectifs immobiliers dans un environnement détendu et de manière honnête, Corina est « véritablement à l’écoute » de ses clients. Elle prend tout le temps nécessaire afin de bien connaître et comprendre leurs attentes. « Ce que je préfère dans l’immobilier c’est… tout! Que ce soit rencontrer mes clients, le travail de bureau ou les visites de maisons. Chaque jour est une aventure que je savoure avec le sourire », affirme Corina. Lorsque vous avez des questions ou des préoccupations concernant l’immobilier, vous pouvez compter sur Corina. Si elle ne connaît pas la réponse, elle saura la trouver.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "114119",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "G9909",
        "TYPE_CERTIFICAT": "AF",
        "NOM": "Boon",
        "PRENOM": "Emy",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 425-0565",
        "TELEPHONE_2": "8194253777",
        "TELEPHONE_FAX": "8194258884",
        "COURRIEL": "eboon@mtre.ca",
        "INSTA":"https://www.instagram.com/emyboon_immobilier/",
        "LINKEDIN":"https://www.linkedin.com/in/emy-boon-57811b150/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/ImmobilierTremblant/",
        "SITE_WEB": "http://www.tremblantrealestate.ca/fr/",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Boon,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "Emy Boon Immobilier Inc.",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "…tant nÈe ‡ Tremblant, et exerÁant dans le domaine de l'immobilier depuis 2016, c'est un privilËge de faire dÈcouvrir notre belle rÈgion ‡ travers l'immobilier, que ce soit pour le ski, les vacances ou pour s'installer de faÁon permanente. Vous pourrez co",
        "PRESENTATION_A": "Being a native of Tremblant, and working in the real estate industry since 2016, it is a privilege to showcase our beautiful region through real estate, whether it be for skiing, vacationing or settling down permanently. You will see my unique perspective",
        "description":"Native de Mont-Tremblant, Emy Boon a acquis au fil des années une grande connaissance de sa région natale ainsi que ses particularités. Possédant un désir marqué, depuis sa jeunesse, de faire connaître sa région et possédant beaucoup d’entre gens, le choix de carrière d’Emy est rapidement devenu une évidence : Le monde de l’immobilier. Ce choix lui permet de créer des relations ainsi que de partager sa passion pour cette belle ville. C’est donc en 2016 qu’elle se joint à l’équipe immobilière Royale Lepage de Mont-Tremblant qui fusionnera en 2018 avec Les Immeubles Mont-Tremblant. Au fils des années, elle a su se bâtir une solide réputation et acquérir le respect de ses collègues et clients. De plus, Emy a la chance de collaborer avec des collègues expérimentés dont certains cumulent même plus de 30 ans d’expérience dans le domaine. Que votre projet immobilier soit en vue d’acquérir un bien locatif, une résidence secondaire ou une résidence permanente, Emy saura vous accompagner et répondre à vos besoins. En effet, sa vision unique et sa connaissance des bijoux bien cachés de la région sauront vous séduire et vous rassurer.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      // {
      //   "CODE": "118613",
      //   "BUR_CODE": "ITT001",
      //   "NO_CERTIFICAT": "H2863",
      //   "TYPE_CERTIFICAT": "CRES",
      //   "NOM": "Couchman",
      //   "PRENOM": "Sean",
      //   "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
      //   "CHAMP_INUTILISE_1": "",
      //   "TELEPHONE_1": "1 (819) 421-2390",
      //   "TELEPHONE_2": "",
      //   "TELEPHONE_FAX": "8194295425",
      //   "COURRIEL": "scouchman@mtre.ca",
      //   "INSTA":"https://www.instagram.com/seancouchman/",
      //   "LINKEDIN":"https://www.instagram.com/seancouchman/",
      //   "FB":"https://www.facebook.com/seancouchmanrealtor/",
      //   "SITE_WEB": "",
      //   "CHAMP_INUTILISE_2": "",
      //   "CODE_LANGUE": "A",
      //   "PHOTO_URL": Couchman,
      //   "DATE_MODIFICATION": "2024/10/09 18:07:35",
      //   "NOM_SOCIETE": "",
      //   "TYPE_SOCIETE_DESC_F": "",
      //   "TYPE_SOCIETE_DESC_A": "",
      //   "LIEN_VIDEO_F": "",
      //   "LIEN_VIDEO_A": "",
      //   "PRESENTATION_F": "",
      //   "PRESENTATION_A": "\r",
      //   "description":"En tant que personne ayant vécu dans la région de Mont-Tremblant depuis plus de 25 ans, Sean a développé une perspective unique sur ce qui fait de la région une destination idéale pour une résidence permanente ou secondaire. Avec plus d’une décennie d’expérience dans les domaines de la vente, du marketing et du service à la clientèle, en plus de posséder des valeurs personnelles fondamentales basées sur le professionnalisme, la persévérance, l’honnêteté et le respect, Sean sera fier de vous fournir une expérience immobilière efficace et agréable.",
      //   "company_info": {
      //     "CODE": "ITT001",
      //     "FIRME_CODE": "ITT",
      //     "NOM_LEGAL": "SIEGE SOCIAL",
      //     "NO_CIVIQUE": "2195",
      //     "NOM_RUE": "Ch. du Village",
      //     "BUREAU": "",
      //     "MUNICIPALITE": "Mont-Tremblant",
      //     "PROVINCE": "QC",
      //     "CODE_POSTAL": "J8E3M3",
      //     "TELEPHONE_1": "8194259324",
      //     "POSTE_1": "",
      //     "TELEPHONE_2": "8194253777",
      //     "POSTE_2": "",
      //     "TELEPHONE_FAX": "8194253640",
      //     "COURRIEL": "info@mtre.ca",
      //     "SITE_WEB": "https://www.tremblantrealestate.ca/",
      //     "DIRECTEUR_CODE": "59807",
      //     "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
      //   }
      // },
      {
        "CODE": "118807",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "H2899",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Martineau",
        "PRENOM": "Emma",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 429-9106",
        "TELEPHONE_2": "8194259324",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "emartineau@mtre.ca",
        "INSTA":"https://www.instagram.com/yourpartnersinrealestate/",
        "LINKEDIN":"https://www.linkedin.com/in/emma-martineau-59215a115/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/VosPart",
        "SITE_WEB": "",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Martineau,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
      "description":"Emma Martineau a la chance d’être née et d’avoir grandi à Mont-Tremblant, et elle apporte ses connaissances et son amour de la région dans sa carrière. Emma est la cinquième génération de sa famille à vivre dans la région et la quatrième génération à travailler comme courtier immobilier. Sa lignée lui fournit les connaissances et l’expérience nécessaires pour savoir à quoi s’attendre et comment atteindre l’objectif. Avant de devenir courtier immobilier, Emma a travaillé dans le domaine du marketing et de la vente pendant ses trois années passées en Angleterre. À son retour dans sa ville natale de Mont-Tremblant en 2017, elle a eu la chance de devenir l’assistante administrative de Kim Richardson. En novembre 2018, Ann Jeffreys s’est jointe à l’équipe et ensemble, elles l’ont encouragée à franchir les prochaines étapes de sa carrière et à obtenir son permis de courtier. La passion d’Emma pour les Laurentides s’est traduite par une carrière, lui permettant de vous aider à découvrir tout ce que cette région a à offrir. Que vous cherchiez à acheter, vendre ou louer, avec Emma et Your Partners in Real Estate, vous pouvez avoir l’esprit tranquille en sachant que vous êtes entre bonnes mains.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "122120",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "H4219",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Bota",
        "PRENOM": "Myriane",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (438) 998-2025",
        "TELEPHONE_2": "8194259324",
        "TELEPHONE_FAX": "8194253640",
        "COURRIEL": "mbota@mtre.ca",
        "INSTA":"https://www.instagram.com/bota.myriane/",
        "LINKEDIN":"https://ca.linkedin.com/in/myriane-bota-3b2a0b36?original_referer=https%3A%2F%2Fwww.google.com%2F",
        "FB":"https://www.facebook.com/people/Myriane-Bota/pfbid02AfcQbKLFEKg2wtR9NrpLo7gviaJiPKHkfk56rKtfkNVb3HEUEwQvHgNm2N8cxMk3l/?paipv=0&eav=AfY_HZNi2g6RL5_wzCrIyjK3gxiMvnjjfZf8c8TLqa1Rrm4gAQqbaX6rhbjI6j4Olto",
        "SITE_WEB": "http://tremblantrealestate.ca",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Bota,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Myriane est une femme d’action qui aime gérer plusieurs projets à la fois. Elle travaille dans le domaine financier depuis de nombreuses années. Elle a débuté en tant que cambiste sur le marché des changes et des produits dérivés, ce qui l’a amenée à travailler dans différents endroits, y compris en Europe. Elle a ensuite couvert le marché des grandes entreprises en développant des stratégies de financement et a rapidement choisi de se spécialiser dans la gestion des liquidités en proposant des innovations technologiques pour aider ses clients à atteindre leurs objectifs. Myriane est titulaire d’un baccalauréat en finance internationale des HEC et d’un MBA de l’Université Concordia. Elle enseigne la finance au niveau universitaire depuis 30 ans, tant au premier qu’au deuxième cycle. Elle aime s’impliquer dans la communauté, elle a été présidente de comités de parents pendant dix ans et gestionnaire d’équipes sportives. Toujours à la recherche de nouveaux défis, c’est en faisant l’acquisition d’un immeuble à Tremblant qu’elle a eu la piqûre pour le domaine et qu’elle a entamé une nouvelle carrière de courtier. Quoi de mieux que de combiner une passion dans un endroit bucolique comme les Laurentides où elle peut pratiquer le ski et les sports d’été avec sa famille. Dévouée et soucieuse du détail, Myriane a à cœur la satisfaction de ses clients et ne ménage ni son temps ni son énergie pour les satisfaire. Elle considère que c’est un privilège de travailler en partenariat avec ses clients pour les aider à atteindre leurs objectifs.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "124251",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "H3725",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Simard",
        "PRENOM": "Katryna",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 325-2989",
        "TELEPHONE_2": "",
        "TELEPHONE_FAX": "",
        "COURRIEL": "ksimard@mtre.ca",
        "INSTA":"https://www.instagram.com/katryna.simard.courtier/",
        "LINKEDIN":"https://www.linkedin.com/in/katryna-simard-b0108b1a4/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/people/Katryna-Simard-Courtier-immobilier-r%C3%A9sidentiel/100047313105314/",
        "SITE_WEB": "http://www.katrynasimard.com",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Simard,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "Katryna Simard Inc.",
        "TYPE_SOCIETE_DESC_F": "SociÈtÈ par actions d'un courtier immobilier rÈsidentiel",
        "TYPE_SOCIETE_DESC_A": "Business corporation owned by a Residential Real Estate Broker",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Katryna Simard est une courtière immobilière passionnée et établie dans la région de Mont-Tremblant et les environs. Avec plus de 15 années d’expérience dans le service à la clientèle, elle s’est forgée une réputation solide en offrant un service exceptionnel à sa clientèle. Depuis ses débuts dans l’industrie, Katryna a toujours placé la satisfaction de ses clients au cœur de son activité. Grâce à son approche personnalisée et à son écoute attentive, elle crée des liens étroits avec ses clients, gagnant ainsi leur confiance et leur fidélité. L’un des atouts majeurs de Katryna est sa connaissance approfondie du marché immobilier des Laurentides. Elle comprend parfaitement les particularités de la région et les tendances du marché. Cette expertise lui permet d’évaluer avec précision les propriétés, de fixer des prix justes et d’offrir des conseils éclairés à ses clients. Katryna sait comment promouvoir efficacement les propriétés, en utilisant les outils les plus innovants et en exploitant son vaste réseau de contacts professionnels. En travaillant avec Katryna, les clients peuvent s’attendre à un accompagnement complet et personnalisé tout au long du processus d’achat ou de vente. Elle est présente à chaque étape, fournissant des conseils d’experts, négociant au nom de ses clients et veillant à ce que toutes les transactions se déroulent en douceur. Son engagement envers l’excellence du service à la clientèle se reflète dans les témoignages élogieux qu’elle reçoit régulièrement de la part de ses clients satisfaits. En dehors de sa carrière immobilière, Katryna est une personne chaleureuse, accessible et passionnée. Elle est connue pour sa personnalité charismatique et sa volonté d’aller au-delà des attentes de ses clients. Son professionnalisme, son intégrité et sa capacité à établir des relations durables font d’elle un choix privilégié pour tous ceux qui recherchent une expérience immobilière exceptionnelle dans les Laurentides.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "127046",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "H5511",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Genest",
        "PRENOM": "Philippe",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (438) 509-4663",
        "TELEPHONE_2": "8194253777",
        "TELEPHONE_FAX": "",
        "COURRIEL":"pgenest@mtre.ca",
        "INSTA":"https://www.instagram.com/philippe_genest/",
        "FB":"https://www.facebook.com/PhilippeGenestCourtierLaurentides?locale=fr_CA",
        // "LINKEDIN":"https://www.linkedin.com/in/laurierbalthazard/overlay/about-this-profile/",
        // "YT":"https://www.youtube.com/channel/UC5weAD8LoYuy8NglL-bwcsA",
        // "SITE_WEB": "https://www.tremblantrealestate.ca/",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Philippe,
        "DATE_MODIFICATION": "2024/10/17 12:18:48",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "SociÈtÈ par actions d'un courtier immobilier rÈsidentiel",
        "TYPE_SOCIETE_DESC_A": "Business corporation owned by a Residential Real Estate Broker",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Ayant plusieurs années d’expérience dans le monde du service à la clientèle, du marketing et de la représentation commerciale, Philippe saura vous offrir un service à la hauteur de vos attentes! Prêt à relever tous les défis, il est constamment en quête d’innovation et à la recherche de nouvelles façons d’optimiser son offre de service! Sa priorité est toujours de vous offrir des stratégies de mise en marché efficaces et la meilleure visibilité pour tous vos projets! C’est d’ailleurs pourquoi Philippe s’est joint aux Immeubles Mont-Tremblant en 2024. Chaque transaction est unique et Philippe s’assurera de vous accompagner dans toutes les étapes. Il est reconnu pour son écoute, son dévouement, sa grande disponibilité et sa capacité à mettre à terme un projet. L’immobilier fait partie de son quotidien et vous constaterez rapidement qu'il exerce son travail avec passion! Ayant à cœur d’offrir un service et une expérience client personnalisé, il sera un conseiller de choix pour vous accompagner dans l’achat et la vente d’une propriété.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "131257",
        "BUR_CODE": "ITT001",
        "NO_CERTIFICAT": "J1072",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Naud",
        "PRENOM": "Myriam",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 210-7879",
        "TELEPHONE_2": "",
        "TELEPHONE_FAX": "",
        "COURRIEL": "mnaud@mtre.ca",
        "INSTA":"https://www.instagram.com/myriam.naud_courtier_tremblant/",
        "LINKEDIN":"https://www.linkedin.com/in/myriam-naud-real-estate-agent-mont-tremblant-a98352274/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/MNaudrealestate/",
        "SITE_WEB": "https://www.tremblantrealestate.ca/brokers/myriam-naud/",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Naud,
        "DATE_MODIFICATION": "2024/10/09 18:07:35",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Forte de sa grande expérience en gestion de clientèles diversifiées et de projets très distinctifs, Myriam a développé une capacité à bâtir des relations basées sur l’intégrité et la transparence. Sa grande capacité d’écoute et sa sensibilité la distinguent quand il est temps de cibler et comprendre les besoins et objectifs des clients. Pour Myriam, la vente ou l’achat d’une propriété exige de grandes responsabilités et du savoir- faire. Myriam est fière de faire partie des Immeubles Mont-Tremblant, agence établie depuis 25 ans, et d’être entourée d’une solide équipe de courtiers chevronnés. Elle désire mettre sa passion pour l’immobilier, l’architecture et la construction au profit de sa clientèle. Originaire de la région de Québec, elle est tombée amoureuse de la région à travers la pratique de différents sports de plein air. Très active, Myriam cumule de nombreuses ascensions en escalade sur les parois rocheuses de l’Utah, l’Arizona, la Californie et l’Ouest Canadien. Kamouraska et la Montagne d’Argent (La Conception) font aussi partie de ses coups de cœur. Ce n’est pas rare de la voir en vélo de montagne, en gravel bike, sur de longues randonnées pédestres et en ski de randonnée. Mont-Tremblant a su lui offrir l’équilibre parfait grâce à toutes les offres et services que cette magnifique région lui propose pour définir son LIFESTYLE. C’est aussi cette passion pour la région et le partage de ses bonnes adresses qu’elle veut faire découvrir aux nouveaux acheteurs. Elle reconnaît que le chemin vers la conclusion d’une transaction immobilière peut parfois être parsemé d’émotions, parfois très heureuses et parfois plus difficiles. C’est pourquoi vous pourrez toujours compter sur son caractère engagé, sa grande discrétion, son intégrité et son impeccable réputation. Elle rendra votre expérience harmonieuse, paisible et agréable.",
        "company_info": {
          "CODE": "ITT001",
          "FIRME_CODE": "ITT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "2195",
          "NOM_RUE": "Ch. du Village",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E3M3",
          "TELEPHONE_1": "8194259324",
          "POSTE_1": "",
          "TELEPHONE_2": "8194253777",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194253640",
          "COURRIEL": "info@mtre.ca",
          "SITE_WEB": "https://www.tremblantrealestate.ca/",
          "DIRECTEUR_CODE": "59807",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD61CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      // {
      //   "CODE": "117917",
      //   "BUR_CODE": "EVT001",
      //   "NO_CERTIFICAT": "D1557",
      //   "TYPE_CERTIFICAT": "CRES",
      //   "NOM": "Bauer",
      //   "PRENOM": "Jan-Otto",
      //   "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
      //   "CHAMP_INUTILISE_1": "",
      //   "TELEPHONE_1": "1 (819) 430-8889",
      //   "TELEPHONE_2": "8004653700",
      //   "TELEPHONE_FAX": "",
      //   "COURRIEL": "jobauer@mtre.ca",
      //   "INSTA":"https://www.instagram.com/janottobauer.immobilier/",
      //   "LINKEDIN":"https://www.linkedin.com/in/jan-otto-bauer-926199105/overlay/about-this-profile/",
      //   "FB":"https://www.facebook.com/janottocourtierimmobilier",
      //   "SITE_WEB": "",
      //   "CHAMP_INUTILISE_2": "",
      //   "CODE_LANGUE": "F",
      //   "PHOTO_URL": Bauer,
      //   "DATE_MODIFICATION": "2024/08/14 11:29:41",
      //   "NOM_SOCIETE": "Gestion AndrÈ Parisien Inc.",
      //   "TYPE_SOCIETE_DESC_F": "SociÈtÈ par actions d'un courtier immobilier rÈsidentiel et commercial",
      //   "TYPE_SOCIETE_DESC_A": "Business corporation owned by a Residential and Commercial Real Estate Broker",
      //   "LIEN_VIDEO_F": "",
      //   "LIEN_VIDEO_A": "",
      //   "PRESENTATION_F": "",
      //   "PRESENTATION_A": "\r",
      //   "description":"Jan-Otto Bauer a eu le privilège de grandir dans la pittoresque ville de Mont-Tremblant. Entourée par la beauté à couper le souffle des montagnes des Laurentides et des lacs sereins, Mont-Tremblant a toujours occupé une place spéciale dans son cœur. Depuis son jeune âge, il a développé une profonde appréciation pour l’industrie immobilière, et c’est pendant ses années formatrices à Mont-Tremblant que sa passion pour les résidences secondaires a commencé à s’épanouir. L’attrait de ces refuges confortables nichés au cœur de la nature est devenu le point central de sa carrière professionnelle. En tant que courtier immobilier d’expérience, Jan-Otto s’est consacré à répondre aux besoins uniques de ceux qui recherchent leur propre oasis tranquille. Fort d’une connaissance approfondie du marché local, il comprend les caractéristiques distinctives et le charme qui rendent chaque propriété vraiment spéciale. En tant que trilingue (français, anglais, allemand), il s’efforce de fournir à ses clients une expérience personnalisée et sans faille. Tout au long de sa carrière, il a développé un solide réseau de clients et de professionnels de l’industrie qui comptent sur son expertise et son dévouement. Jan-Otto se tient informé des tendances du marché, des valeurs immobilières et des dernières avancées dans l’industrie immobilière lui permettant d’offrir des conseils éclairés et des stratégies sur mesure à ses clients, garantissant ainsi la réussite de leurs objectifs immobiliers. Comme Jan-Otto le dit si bien : “Une résidence dans les Laurentides est bien plus qu’un simple investissement immobilier, c’est un sanctuaire où des souvenirs sont créés et chéris pour toute une vie”.",
      //   "company_info": {
      //     "CODE": "EVT001",
      //     "FIRME_CODE": "EVT",
      //     "NOM_LEGAL": "SIEGE SOCIAL",
      //     "NO_CIVIQUE": "1000",
      //     "NOM_RUE": "Chemin des Voyageurs",
      //     "BUREAU": "",
      //     "MUNICIPALITE": "Mont-Tremblant",
      //     "PROVINCE": "QC",
      //     "CODE_POSTAL": "J8E1T1",
      //     "TELEPHONE_1": "8196815000",
      //     "POSTE_1": "",
      //     "TELEPHONE_2": "",
      //     "POSTE_2": "",
      //     "TELEPHONE_FAX": "8196815700",
      //     "COURRIEL": "tremblant@evrealestate.com",
      //     "SITE_WEB": "",
      //     "DIRECTEUR_CODE": "91377",
      //     "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDDFCFDDDB0842DDA&t=b&w=200&h=150"
      //   }
      // },
      {
        "CODE": "58481",
        "BUR_CODE": "EVT001",
        "NO_CERTIFICAT": "H1290",
        "TYPE_CERTIFICAT": "AF",
        "NOM": "Ouimet",
        "PRENOM": "Pierre",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 429-0730",
        "TELEPHONE_2": "8196815000",
        "TELEPHONE_FAX": "8196815700",
        "COURRIEL": "pouimet@mtre.ca",
        "LINKEDIN":"https://www.linkedin.com/in/pierre-ouimet-84243536/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/pierreetcynthialesimmeublesmonttremblant",
        "SITE_WEB": "http://www.pierreetcynthia.com",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Ouimet,
        "DATE_MODIFICATION": "2024/08/14 11:29:42",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Pierre est originaire de Mont-Tremblant et a commencé sa carrière comme courtier en 1988. Après 31 ans dans le domaine, il a toujours la passion et l’engagement nécessaires pour répondre aux besoins de ses clients. Il connaît très bien les nombreux lacs et communautés qui entourent Mont-Tremblant. Son expertise en immobilier, tant résidentielle que commerciale, lui a permis de se démarquer nettement auprès de ses clients. Il y a 12 ans, il a décidé de s’associer à Cynthia Griffin et ensemble, ils ont bâti une clientèle internationale et locale réputée. En tant qu’équipe bilingue, Pierre et Cynthia promettent qu’ils ont TOUT POUR VOUS AIDER!",
        "company_info": {
          "CODE": "EVT001",
          "FIRME_CODE": "EVT",
          "NOM_LEGAL": "SIEGE SOCIAL",
          "NO_CIVIQUE": "1000",
          "NOM_RUE": "Chemin des Voyageurs",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E1T1",
          "TELEPHONE_1": "8196815000",
          "POSTE_1": "",
          "TELEPHONE_2": "",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8196815700",
          "COURRIEL": "tremblant@evrealestate.com",
          "SITE_WEB": "",
          "DIRECTEUR_CODE": "91377",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDDFCFDDDB0842DDA&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "87724",
        "BUR_CODE": "500407",
        "NO_CERTIFICAT": "C9977",
        "TYPE_CERTIFICAT": "AF",
        "NOM": "Griffin",
        "PRENOM": "Cynthia",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (819) 421-4663",
        "TELEPHONE_2": "",
        "TELEPHONE_FAX": "",
        "COURRIEL": "cgriffin@mtre.ca",
        "LINKEDIN":"https://www.linkedin.com/in/cynthiagriffin1/overlay/about-this-profile/",
        "FB":"https://www.facebook.com/pierreetcynthialesimmeublesmonttremblant",
        "SITE_WEB": "",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "A",
        "PHOTO_URL": Griffin,
        "DATE_MODIFICATION": "2024/09/30 17:26:37",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Cynthia a grandi à Montréal où elle menait une vie sportive et a eu l’immense chance d’être initiée à Tremblant lorsqu’elle était toute jeune, car sa famille venait dans le Nord pour skier chaque fin de semaine. Elle est rapidement tombée amoureuse de Mont-Tremblant et a décidé de s’installer ici après ses études. Elle a travaillé dans l’industrie du ski et du golf tout en prenant soin de ses deux enfants. En 2006, sa carrière dans l’immobilier a commencé avec sa connaissance et son appréciation de la région et c’est devenu une seconde nature chez elle! La créativité, la socialisation, l’organisation et l’appui envers les autres sont ses spécialités. Donc, quand vous lui donnez les critères idéaux pour votre maison de rêve, elle est en mesure de la trouver pour vous. Elle s’est associée à Pierre Ouimet en 2007 et ils sont devenus une équipe immobilière bilingue qui connaît beaucoup de succès. Comme on peut le lire sur leur logo, TOUT POUR VOUS AIDER!",
        "company_info": {
          "CODE": "500407",
          "FIRME_CODE": "EGV",
          "NOM_LEGAL": "Pointe-Claire",
          "NO_CIVIQUE": "288",
          "NOM_RUE": "ch. du Bord-du-Lac (Lakeshore)",
          "BUREAU": "",
          "MUNICIPALITE": "Pointe-Claire",
          "PROVINCE": "QC",
          "CODE_POSTAL": "H9S4K9",
          "TELEPHONE_1": "5145077888",
          "POSTE_1": "",
          "TELEPHONE_2": "",
          "POSTE_2": "",
          "TELEPHONE_FAX": "",
          "COURRIEL": "montreal@evcanada.com",
          "SITE_WEB": "",
          "DIRECTEUR_CODE": "84903",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD65CDDDB0842DD1&t=b&w=200&h=150"
        }
      },
      {
        "CODE": "113426",
        "BUR_CODE": "HMA006",
        "NO_CERTIFICAT": "H6230",
        "TYPE_CERTIFICAT": "CRES",
        "NOM": "Lambert",
        "PRENOM": "Véronique",
        "TITRE_PROFESSIONNEL": "Courtier Immobilier Résidentiel",
        "CHAMP_INUTILISE_1": "",
        "TELEPHONE_1": "1 (514) 993-8778",
        "TELEPHONE_2": "",
        "TELEPHONE_FAX": "",
        "COURRIEL": "vlambert@mtre.ca",
        "INSTA":"https://www.instagram.com/veronique_mont_tremblant/",
        "LINKEDIN":"https://www.linkedin.com/in/veronique-lambert-870b2a145/",
        "FB":"https://www.facebook.com/veronique.lambert.372",
        "SITE_WEB": "www.royallepagehumania.ca",
        "CHAMP_INUTILISE_2": "",
        "CODE_LANGUE": "F",
        "PHOTO_URL": Lambert,
        "DATE_MODIFICATION": "2023/04/06 14:02:16",
        "NOM_SOCIETE": "",
        "TYPE_SOCIETE_DESC_F": "",
        "TYPE_SOCIETE_DESC_A": "",
        "LIEN_VIDEO_F": "",
        "LIEN_VIDEO_A": "",
        "PRESENTATION_F": "",
        "PRESENTATION_A": "\r",
        "description":"Véronique vit à Mont-Tremblant depuis plusieurs années et possède plusieurs propriétés situées à la montagne. Son implication dans la communauté lui a permis de développer un excellent réseau de contacts impliqués dans le domaine de l’immobilier et avec plusieurs fournisseurs de services nécessaires à la réalisation des transactions immobilières réussies. Technicienne en architecture et auteure de plusieurs projets d’auto-construction, Véronique a récemment décidé de mettre à profit ses compétences et son expérience en tant que courtier immobilier. Athlète accomplie et réputée dans la région, cette mère de deux jeunes adultes se distingue par sa grande capacité d’écoute et son dévouement envers ses clients. Son dynamisme, son enthousiasme et sa grande détermination vous permettront de réaliser votre rêve immobilier.",
        "company_info": {
          "CODE": "HMA006",
          "FIRME_CODE": "HMA",
          "NOM_LEGAL": "Mont-Tremblant",
          "NO_CIVIQUE": "3-614",
          "NOM_RUE": "rue de Saint-Jovite",
          "BUREAU": "",
          "MUNICIPALITE": "Mont-Tremblant",
          "PROVINCE": "QC",
          "CODE_POSTAL": "J8E0T4",
          "TELEPHONE_1": "8194296464",
          "POSTE_1": "",
          "TELEPHONE_2": "",
          "POSTE_2": "",
          "TELEPHONE_FAX": "8194295425",
          "COURRIEL": "Humania@royallepage.ca",
          "SITE_WEB": "",
          "DIRECTEUR_CODE": "102299",
          "URL_LOGO_BUREAU": "https://mediaserver.centris.ca/media.ashx?id=ADDE1A2DDDDD763DDDB0842DDE&t=b&w=200&h=150"
        }
      }
  ]

